import React from 'react';
import { FormattedMessage } from 'react-intl';
import banners, { BannerTypes } from '@gin-betting/banners';
import { App } from '@gin-betting/core';

import {
    Carousel,
    PromoItem,
    Spinner,
    SportEventSeoMicromarking,
} from 'components';
import { AsyncOddButton } from 'modules/betslip/async';
import favorite from 'modules/favorite';
import { Action, AnalyticAttrsCtx, Category } from 'services/analytics';
import messages from '../../messages';
import TopMatchTabs from '../TopMatchTabs';
import useTopMatch from './useTopMatch';

import './topMatch.scss';

const {
    components: { ToggleFavoriteButton },
} = favorite;
const {
    hocs: { withAvailableZoneByAttributes },
} = banners;

const ANALYTICS_ODD_BTN = {
    'data-category': Category.TopSportEventsRight,
    'data-action': Action.SelectOdd,
};

const TopMatch: React.FC<BannerTypes.WithAvailableZoneProps> = ({ zoneId }) => {
    const {
        sports,
        sportEventIds,
        activeSportId,
        handleTabChange,
        preloadMatches,
        fetchStatus,
        isLoadingTimedOut,
    } = useTopMatch({ zoneId });

    if (sportEventIds.length === 0) {
        if (fetchStatus === App.FetchStatus.LOADING && !isLoadingTimedOut)
            return (
                <div styleName="spinner ">
                    <Spinner />
                </div>
            );

        return null;
    }

    return (
        <div styleName="container">
            <div styleName="header">
                <span styleName="header-title">
                    <FormattedMessage {...messages.topMatch} />
                </span>
            </div>

            <TopMatchTabs
                sports={sports}
                activeSportId={activeSportId}
                onTabChange={handleTabChange}
                onInactiveTabHover={preloadMatches}
            />

            <Carousel
                key={activeSportId}
                hasControls={true}
                direction="left"
                delay={20000}
            >
                {sportEventIds.map(matchId => (
                    <React.Fragment key={matchId}>
                        <AnalyticAttrsCtx.Provider value={ANALYTICS_ODD_BTN}>
                            <PromoItem
                                matchId={matchId}
                                AsyncOddButton={AsyncOddButton}
                                favoriteButton={
                                    <ToggleFavoriteButton matchId={matchId} />
                                }
                            />
                        </AnalyticAttrsCtx.Provider>

                        <SportEventSeoMicromarking sportEventId={matchId} />
                    </React.Fragment>
                ))}
            </Carousel>
        </div>
    );
};

export default withAvailableZoneByAttributes(TopMatch);
